var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseModal,{staticClass:"country-switcher-modal",attrs:{"title":_setup.modalTitle}},[_c('div',{staticClass:"country-switcher-modal-content"},[_c('div',{key:"country"},[_c(_setup.CountryList,{attrs:{"additionalContexts":_vm.additionalContexts},on:{"selected-country":_setup.closeSelf}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }